import React, {  } from 'react';
import './Header.css';
import SASLOGO from './../../assets/hsdm.png';
import HRYLOGO from './../../assets/hkcl.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
const Header = () => {
  

  return (
    <div style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 10 }}>
      <div className='headertop' style={{ padding: '8px 45px', background: 'linear-gradient(150deg,rgb(54, 122, 232) 0%,rgb(107, 150, 194) 100%)',color:"white"}}>
      <span className="me-3"> <FontAwesomeIcon icon={faPhone} className='me-2'/><span className="">0172-5210290/291</span></span>
      <span className=""> <FontAwesomeIcon icon={faEnvelope} className='me-2' /><span className="">info@hkcl.in</span></span>
      </div>
      <header style={{  position: 'relative' }}>
        <div className='container-fluid'>
          <div className="d-flex align-items-center justify-content-center" style={{position:"relative"}}>
            
            <div className="col-md-1 col-xs-4 text-center"  >
              <img src={SASLOGO} alt='Right Logo' width={90}  />
            </div>
            <div className="col-md-9 col-xs-8 mt-3">
              <h3 className='mobiletext' style={{  color: '#e51d2a', margin: 0 }}>
            <div className='text-dark fw-bold mobp' style={{textTransform:"uppercase",fontSize:"1.1rem"}}>Department of</div>
                <div className='fw-bolder mobp' style={{textTransform:"uppercase",color:"#0b50dd"}}>Haryana Kaushal Rozgar Nigam</div>
                <p className='text-dark fw-bold mobpb' style={{textTransform:"uppercase",fontSize:"0.9rem"}}><i>Government of Haryana</i></p>
              </h3>
            </div>
            <div className="col-md-2 col-xs-4 text-end mobileview" >
              <img src={ HRYLOGO} alt='Department Logo' width={105} />
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
